import React, { memo, useEffect } from 'react';
import { useSceneStore, useUserStore } from '../../../zustand';
import * as CSS from './PlacementUI.scss';
// import { getTranslation, ITranslationKey } from '@/translations';
import placedIcon24Url from '../../../assets/check24.svg'
import replaceIcon24Url from '../../../assets/move24.svg'

type IParentProps = {
	onPlacementModeChange: (e: any) => any;
	activeGesture?: boolean;
	enabled?: boolean;
};

const PlacementUI: React.FC<IParentProps> = ({ onPlacementModeChange, activeGesture = false, enabled = false }) => {
	const placementMode = useSceneStore(({ placementMode }) => placementMode);
	const placementModeUiVisible = useUserStore(({ placementModeUiVisible }) => placementModeUiVisible);
	const canvasDiv = document.getElementById('zapparCanvas');

	useEffect(() => {
		if (!enabled) return;
		if (!canvasDiv) return;

		const containerDiv = document.createElement('div');
		containerDiv.id = 'placementUiContainer';
		containerDiv.className = CSS.Container;
		containerDiv.style.height = '100%';
		containerDiv.style.position = 'absolute';
		containerDiv.style.background = placementMode ? 'linear-gradient(0deg, rgba(0,0,0,0.5), rgba(255,255,255,0.0) 70%, rgba(0,0,0,0.5))' : 'none';

		const placementButton = document.createElement('button');

		placementButton.id = 'placementUiButton';
		placementButton.className = CSS.PlacementButton;
		placementButton.addEventListener('pointerdown', e => e.stopPropagation());
		placementButton.addEventListener('pointerup', e => e.stopPropagation());
		placementButton.addEventListener('click', e => {
			e.stopPropagation();
			onPlacementModeChange(e)
		})

		const iconImg = document.createElement('img');
		iconImg.src = placementMode ? placedIcon24Url : replaceIcon24Url;
		iconImg.className = CSS.PlacementIcon;
		placementButton.appendChild(iconImg)

		// placementButton.innerText = getTranslation(placementMode ? ITranslationKey.place : ITranslationKey.reset, true);

		containerDiv.appendChild(placementButton);
		canvasDiv.appendChild(containerDiv);

		return () => {
			const canvasDiv = document.getElementById('zapparCanvas');
			const containerDiv = document.getElementById('placementUiContainer');
			if (!canvasDiv || !containerDiv) return;
			canvasDiv.removeChild(containerDiv);
		};
	}, [placementMode, activeGesture, enabled, placementModeUiVisible, onPlacementModeChange]);

	return null;
};

export default memo(PlacementUI);
